import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {
	transform(value: string): string {
		// Remove HTML tags and various zero-width space characters, then trim any leading or trailing spaces
		return value
			?.replace(/<.*?>|&ZeroWidthSpace;|\u200B|\u200C|\u200D|\uFEFF/g, '')
			.trim();
	}
}
